import { CheckoutRoute } from "@swiggy-private/checkout-core";

export const CUSTOM_BACK_HANDLING_ROUTES = [
    CheckoutRoute.CART,
    CheckoutRoute.GIFTING_CART,
    CheckoutRoute.MRO_FOOD_CART,
    CheckoutRoute.QUICK_CHECKOUT,
];
